import VCheckbox from './VCheckbox.vue';

export { VCheckbox };
export default VCheckbox;
